import {
  CUSTOM_FIELD_MAX_SINGLE_LINE_LENGTH,
  FILTER_TITLE_MAX_LENGTH,
  INITIATIVE_TITLE_MAX_LENGTH,
} from '../constants';
import { CHARACTER_LIMITS } from '../constants/character-limits';

export const truncateFieldValue = (value: string, maxLength: number): string => {
  if (!value || value.length <= maxLength) {
    return value;
  }
  // Truncate without ellipsis to maximize usable characters
  return value.substring(0, maxLength);
};

export const truncateSingleLineField = (value: string): string => {
  return truncateFieldValue(value, CUSTOM_FIELD_MAX_SINGLE_LINE_LENGTH);
};

export const truncateMultiLineField = (value: string): string => {
  return truncateFieldValue(value, CHARACTER_LIMITS.LARGE_FIELD);
};

export const truncateTitle = (value: string): string => {
  return truncateFieldValue(value, INITIATIVE_TITLE_MAX_LENGTH);
};

export const truncateFilterValue = (value: string): string => {
  // For multi-filter values (comma-separated), truncate each part to filter limit
  if (value.includes(',')) {
    return value
      .split(',')
      .map(item => truncateFieldValue(item.trim(), FILTER_TITLE_MAX_LENGTH))
      .join(',');
  }
  return truncateFieldValue(value, FILTER_TITLE_MAX_LENGTH);
};

export const truncateBudgetField = (value: string): string => {
  return truncateFieldValue(value, CHARACTER_LIMITS.LARGE_FIELD);
};
